import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import { emailValidationCommit } from '../../../services/authentication/emailvalidation/actions';

import { isTokenExpired } from '../../../services/authentication/utils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { LoadingComponent } from '../../loading/LoadingComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './EmailValidationPage.scss';

class EmailValidationPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { missingParam: false };
    }

    componentDidMount() {
        if (this.props.match.params.email && this.props.match.params.token) {
            this.props.emailValidationCommit(
                this.props.match.params.email,
                this.props.match.params.token
            );
        } else {
            this.setState({ missingParam: true });
        }
    }

    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }

    isMemberAuthenticated = () => !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history }) {
        if (this.isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                history.push(PATH.HOME_PATH);
                resolve();
            });
        }
    }

    renderMessage = () => {
        const { i18n, requestSubmit, successSubmit, errorSubmit } = this.props;
        const { missingParam } = this.state;

        if (requestSubmit) {
            return <LoadingComponent />;
        }
        if (missingParam || errorSubmit || !successSubmit) {
            return <p className="error">{i18n.ERROR_MESSAGE}</p>;
        }
        if (successSubmit) {
            return <p className="success">{i18n.SUCCESS_MESSAGE}</p>;
        }
    };

    render() {
        const { i18n } = this.props;
        return (
            <main id="p-validation-email" className="conteneur">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={`${PATH.EMAIL_VALIDATION_PATH}/:email/:token`}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>

                {this.renderMessage()}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EMAIL_VALIDATION,
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated,
        errorMessage: state.authentication.emailvalidation.error || '',
        requestSubmit: state.authentication.emailvalidation.fetching || false,
        successSubmit: state.authentication.emailvalidation.success || false,
        errorSubmit: !isEmpty(state.authentication.emailvalidation.error)
    };
};

const mapDispatchToProps = {
    emailValidationCommit
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(EmailValidationPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/emailvalidation/EmailValidationPage.js